import { createSlice } from '@reduxjs/toolkit';
import { strText } from '../../../constants';
import { loginUser } from '../actions/auth';


const initialState = {
    loading: false,
    token: '',
    errorMsg: null,
    success_msg: null,
    userData: {
        contact_email: '',
        fullname: '',
        firstname: '',
        lastname: '',
        phone_number: '',
        bank_name: '',
        user_role: '',
        user_role_id: '',
        user_bank_role: '',
        isProfileComplete: '',
        isAdmin: '',
        email: ''
    },
    userTemporaryDetails:{
        email: ''
    },
    email: '',
    isEmailVerificationModal: false,
}

export const authSlice = createSlice({
    name: 'authApp',
    initialState,
    reducers: {
        clearAll: (state, action) => {
            state.loading = false
            state.errorMsg = null
            state.success_msg = null
        },
        setLoading: (state, action) => {
            state.loading = action?.payload?.loading
        },
        logoutUser: (state) => {
            localStorage.removeItem(`${strText.user_unique_id}`)
            state.loading = false
            state.token = ''
            state.errorMsg = null
            state.success_msg = null
            state.email = ''
            state.userData = {
                contact_email: '',
                fullname: '',
                firstname: '',
                lastname: '',
                phone_number: '',
                bank_name: '',
                user_bank_role: '',
                user_role: '',
                user_role_id: '',
                isProfileComplete: '',
                isAdmin: '',
                email: ''
            }
            state.userTemporaryDetails ={
                email: ''
            }
            state.isEmailVerificationModal = false
        },
        setErrorMessage: (state, action) => {
            let msg = action.payload.message
            state.loading = false
            state.errorMsg = msg === 'Request failed with status code 401'
                ?
                'Invalid Credentials'
                :
                msg === 'Request failed with status code 429'
                    ?
                    'Too many failed attempts, Kindly try again in the next 15 min'
                    :
                    msg
        },
        setTempEmail: (state, action) => {
            state.tempEmail = action.payload
        },
        onEmailVerification: (state, action) => {
            state.success_msg = action.payload.message
            state.authSize = {
                'one'  : 'col-sm-12 col-md-4',
                'two'  : 'col-sm-12 col-md-4',
                'three': 'col-sm-12 col-md-4 authLoginWrapperThree'
            }
        },
        onUserLogin: (state, action) => {
            let userDetails = action.payload
            let temp_token = action.payload.token
            localStorage.setItem(`${strText.user_unique_id}`, temp_token);
            state.token = temp_token
            state.loading = false
            state.userData = {
                contact_email: userDetails?.profile?.contact_email,
                fullname: `${userDetails?.firstname ?? ''} ${userDetails?.lastname ?? ''}`,
                firstname: userDetails?.firstname,
                lastname: userDetails?.lastname,
                phone_number: userDetails?.profile?.phone_number,
                bank_name: userDetails?.profile?.bank_name,
                user_bank_role: userDetails?.profile?.user_bank_role,
                user_role: userDetails?.userRole,
                user_role_id: userDetails?.userRoleId,
                isProfileComplete: userDetails?.isProfileComplete,
                isAdmin: userDetails?.isAdmin,
                email: userDetails?.EMAIL
            }
            state.success_msg = action.payload.message
        },
        onOnboardUser: (state, action) =>  {
            state.loading = false
            state.userTemporaryDetails = {...state.userTemporaryDetails, ...action.payload}       
        },        
        setUserEmail: (state, action) => {
            state.email = action.payload.email
        },
        changeModalSize: (state,action) => {
            state.modalSize = action?.payload?.type
            state.authSize = {
                'one'  : 'col-sm-12 col-md-4',
                'two'  : 'col-sm-12 col-md-4',
                'three': 'col-sm-12 col-md-4 authLoginWrapper'
            }
        },

        //end of used method
        setActivityTiming: (state, action) => {
            let newD = new Date();
            state.loginTime = newD.getTime()
        },
    },
    extraReducers: (builder) => {
        builder.addCase(loginUser.fulfilled, (state, action) => {
            const userDetails = action.payload.data;
            const token = action.payload.data.token;
            
            state.token = token;
            state.loading = false;
            
            localStorage.setItem(strText.user_unique_id, token);
            
            state.userData = {
                contact_email: userDetails?.profile?.contact_email,
                fullname: `${userDetails?.firstname ?? ''} ${userDetails?.lastname ?? ''}`,
                firstname: userDetails?.firstname,
                lastname: userDetails?.lastname,
                phone_number: userDetails?.profile?.phone_number,
                bank_name: userDetails?.profile?.bank_name,
                user_bank_role: userDetails?.profile?.user_bank_role,
                user_role: userDetails?.userRole,
                user_role_id: userDetails?.userRoleId,
                isProfileComplete: userDetails?.isProfileComplete,
                isAdmin: userDetails?.isAdmin,
                email: userDetails?.EMAIL
            };

            state.errorMsg = null;
            state.success_msg = action.payload.message
        })
        .addCase(loginUser.rejected, (state, action) => {
            state.loading = false;

            if (action.payload) state.errorMsg = action.payload.error || action.payload.message;
            else state.errorMsg = action.error.message;
        })
        .addCase(loginUser.pending, (state, action) => {
            state.loading = true;
            state.errorMsg = null;
        });
    }
})

// Action creators are generated for each case reducer function
export const {
    logoutUser,
    setTempEmail,
    onEmailVerification,

    //
    setErrorMessage,
    setLoading,
    onUserLogin,
    onOnboardUser,
    clearAll,
    setUserEmail,
    setActivityTiming
} = authSlice.actions

export default authSlice.reducer